module.exports = __webpack_public_path__ + "img/za.55fa948.webp";